import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { Button } from '@/atoms/Button'
import { useAngelPlayerContext } from '@/organisms/AngelPlayer'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'

export const SkipIntroOverlay: FC = () => {
  const track = useSafeTrack()
  const { onSkip, inIntro, playing, episodeGuid } = useAngelPlayerContext()
  const { t } = useTranslate('watch')

  const onHandleSkip = () => {
    onSkip()
    track('Skipped Intro', {
      guid: episodeGuid,
    })
  }

  const variants = {
    open: {
      opacity: 1,
      y: -8,
      x: -70,
      transition: {
        type: 'spring',
        bounce: 0.2,
        duration: 0.6,
      },
    },
    closed: { x: -70, y: 40, opacity: 0, display: 'none' },
  }

  const showSkip = Boolean(inIntro && playing)

  return (
    <div
      className={classNames(
        'text-[10px] sm:text-base absolute -right-12 top-6 sm:top-auto z-40 bottom-auto sm:bottom-24 sm:right-6',
      )}
      id="fullscreen-skip-intro"
    >
      <motion.div animate={showSkip ? 'open' : 'closed'} variants={variants}>
        <Button onClick={onHandleSkip} variant="oxide-bright">
          {t('skipIntro', 'Skip Intro')}
        </Button>
      </motion.div>
    </div>
  )
}
